import {
  ACTION_CANCEL_WIRE__REQUEST,
  ACTION_CANCEL_WIRE__SUCCESS,
  ACTION_CANCEL_WIRE__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_CANCEL_WIRE__REQUEST:
    case ACTION_CANCEL_WIRE__SUCCESS:
      return null;

    case ACTION_CANCEL_WIRE__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
